import './autocomplete';
import playSound from './play-sound';

(function ($) {
    var debounceTime = (function() {
        var timeoutId;
        return function(callback, time) {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            timeoutId = setTimeout(callback, time);
        };
    })();

    var requestAjax;

    $.widget("ca.caUserPicker", $.ca.caAutocomplete, {
        options: {
            url: '/layout/user-autocomplete',
            data: {
                alsoFindByCode: true,
                noResultsAlert: true
            },
            limit: 10,
            customData : false,
            advanceSearch: false,
            source: function(request, response) {
                var self = this;
                if (this.options.url) {
                    var data = $.extend(this.options.data, {
                        limit: this.options.limit,
                        input: request.term
                    });

                    if(self.options.customData){
                        data = $.extend(data, self.options.customData);
                    }

                    var codeRegExp = this.options.codeRegExp;

                    self.searchCompleted = false;
                    var makeRequest = function() {
                        if (requestAjax) {
                            requestAjax.abort();
                        }

                        requestAjax = $.ajax({
                            url: self.options.url,
                            type: 'POST',
                            dataType: "json",
                            data: data,
                            success: function (result) {
                                if (self.options.data.alsoFindByCode
                                    && result.length == 1
                                    && result[0].byContractNum
                                ) {
                                        self.item = result[0];
                                        self.findByAccessCard = true;

                                        if(!self.options.enterPressed){
                                            return true;
                                        }

                                }

                                var countUsers = $(result).length;

                                if (!countUsers && data.noResultsAlert && data.input.match(codeRegExp) && self.options.enterPressed && !isNaN(data.input)) {
                                    self.__displayAlert();

                                    // CA-6677
                                    // we need to execute that instantly without waiting someone to click "x" for popup
                                    self.element.val('');
                                    self.close();
                                    return true;
                                } else if(self.item !== null && self.findByAccessCard && self.options.enterPressed && !isNaN(data.input)){
                                        self._trigger('select', {}, {item: result[0]});
                                        self.findByAccessCard = false;
                                        return true;

                                } else if(!countUsers && data.noResultsAlert && data.input.length === 10  && data.input.match(codeRegExp)){
                                    self.__displayAlert();
                                    return true;
                                }

                                if(!isNaN(data.input)){

                                    self.searchCompleted = true;
                                    if(!countUsers && data.input.length !== 10){
                                        return true;
                                    }
                                }


                                if(data.input.match(codeRegExp) && countUsers >= 1 && !self.findByAccessCard && self.options.enterPressed) {

                                    $.caPost(self.options.searchDialogUrl, {
                                        inputText: data.input
                                    }, function (response) {
                                        if (response.status == 1) {
                                            $(response.content).appendTo('body');
                                            self.element.val('');
                                            self.element.blur();
                                        } else {
                                            $.caAlert(response.message);
                                        }
                                    }, 'json');
                                }

                                response(result);

                                if (typeof self.options.onAfterSuccessCallback === 'function') {
                                    self.options.onAfterSuccessCallback(result);
                                }
                            }
                        });
                    };

                    debounceTime(
                        makeRequest,
                        700
                    );
                }
            },
            items: {},
            changeable: true,
            showCreateButton: true,
            showAddGuestButton: false,
            notFoundText: 'User not found',
            addGuestText: 'Add Guest',
            placeholder: 'Select user',
            removeText: 'Remove Name',
            multiple: false,
            codeRegExp : /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im,   // doesn't contain any spaces and contains at least one digit
            elementEnterPress: true,
            enterPressed: false,
            beforePressEnter: function(inputText, items) {
                if (inputText.match(this.options.codeRegExp)) {
                    //clear items
                    this.close();

                    var doNotShow = this.options.data.doNotShow;
                    this.options.data.doNotShow = [];

                    //remember that enter was pressed and clear this flag when we get suggestions
                    this.options.enterPressed = true;
                    $.ui.autocomplete.prototype.search.call(this, inputText);
                    this.options.data.doNotShow = doNotShow;
                }
            }
        },
        findByAccessCard: false,
        item: null,
        searchCompleted: false,

        _create: function() {
            $.ca.caAutocomplete.prototype._create.call(this);

            var self = this;
            var options = this.options;

            // disabling the default search if a member scans in their access card
            if (options.data.alsoFindByCode) {
                self.options.enterPressed = false;
                this.options.search = function () {
                    if (self.options.enterPressed) {
                        options.items = [];
                        // allow multiple times search
                        return true;
                    }
                };
            }

            this.element.on('keydown', function (event) {

                if (event.which === 13) {
                    self.options.enterPressed  = true;
                    if(self.findByAccessCard && self.item){
                        var textValue = $(this).val();
                        self._trigger('select', {}, {item: self.item});
                        self.findByAccessCard = false;
                        self.item = null;
                        $(this).val(textValue);
                        return true;
                    } else if(self.searchCompleted && self.item === null && $(this).val().length !== 10){
                        self.__displayAlert();
                        self.searchCompleted = false;
                        return true;
                    }

                }
            });
        },

        _renderItem: function (ul, item) {
            var li = $('<li>').data('item.autocomplete', item);
            var a = $('<a>').appendTo(li);

            if (item.isActive != undefined && item.isActive == true) {
                li.addClass('autocomplete-active');
            } else if (item.isStaff != undefined && item.isStaff == true) {
                li.addClass('autocomplete-staff');
            } else if (item.isExpired != undefined && item.isExpired == true) {
                li.addClass('autocomplete-inactive');
            } else if (item.isNotMember != undefined && item.isNotMember == true) {
                li.addClass('autocomplete-not-members');
            }

            var nameWithHighlightedTerm = item.label;
            if (item.label) {
                if (item.highlightLabel !== undefined) {
                    nameWithHighlightedTerm =
                        item.highlightLabel
                        || item.label.replace(
                            new RegExp($.trim(this.term), "gi"),
                            '<span class="user-picker-highlighted" >$&</span>'
                        );
                }
            }

            var description = (item.description === undefined) ? '' : item.description;
            var picture = (item.picture == undefined) ? '' : '<img src="' + item.picture + '" />';

            var html = picture
                + '<p class="user-picker-name">' + nameWithHighlightedTerm + '&nbsp;</p>'
                + '<p class="user-picker-description">' + description + '&nbsp;</p>';

            $(html).appendTo(a);
            li.appendTo(ul);

            return li;
        },

        _suggest: function (items) {
            var self = this;

            // if a member scans in their access card and only 1 element found
            if (self.options.data.alsoFindByCode
                && items.length == 1
                && items[0].byContractNum
            ) {

                if (self.options.enterPressed == true) {
                    self._trigger('select', {}, {item: items[0]});
                    return true;
                }
                self.findByAccessCard = true;
                self.item = items[0];

                //clear enter was pressed flag
                self.options.enterPressed = false;
                return true;
            } else if(items.length === 1
                      && self.options.advanceSearch
                      && items[0].byEmailOrPhone
            ) {
                self.item = items[0];
                self.findByAccessCard = true;
            }

            //clear enter was pressed flag
            self.options.enterPressed = false;

            $.ui.autocomplete.prototype._suggest.call(this, items);

            var menu = this.menu.element;

            menu.addClass('ca-user-picker-menu').removeClass('ui-widget-content');
            menu.find('li a').removeClass('ui-corner-all');
            menu.find('img').addClass('ui-corner-all');

            if (items.length == 0) {
                $('<li class="item-not-found">' + self.options.notFoundText + '</li>').appendTo(menu);
            }
            menu.css('min-width', '140px');

            if (self.options.showCreateButton) {
                menu.css({'width': 'auto', 'min-width': 'auto'});

                var isCorporate = 0;
                if (this.options.data.onlyCorporate !== undefined) {
                    isCorporate = this.options.data.onlyCorporate;
                }

                var parentId = 0;
                if (this.options.data.parentId !== undefined) {
                    parentId = this.options.data.parentId;
                }

                $('<li class="ui-menu-item create-new-client" aria-label="Create New Client"><a href="#"><div><div>Create New Client</div></div></a></li>')
                    .appendTo(menu)
                    .find('a')
                    .on('click', function () {
                        $(self.element).caCreateNewClient({isCorporate: isCorporate});
                        $(self.element).caCreateNewClient({parentId: parentId});
                        $(self.element).caCreateNewClient('setName', self.element.val()).caCreateNewClient('open');
                        self.close();
                        return false;
                    })
                    .on('mouseenter mouseleave', function () {
                        return false;
                    });
            }

            if (self.options.showAddGuestButton) {
                menu.css('min-width', '211px');
                $('<li class="ui-menu-item create-new-client"><a href="#"><div><div>' + self.options.addGuestText + '</div></div></a></li>')
                    .appendTo(menu)
                    .find('a')
                    .on('click', function () {
                        var newGuest = {
                            id: '-1',
                            label: self.element.val().toLowerCase().replace('"', '&quot;')
                        };
                        self._trigger('select', {}, {item: newGuest});
                        self.close();
                        return false;
                    })
                    .css('height', 'auto')
                    .on('mouseenter mouseleave', function () {
                        return false;
                    });
            }
        },
        __displayAlert: function(){
            playSound.playFail();
            var accessCardErrorMessage = 'This access card # does not exist.';
            if(this.options.advanceSearch === 1){
                accessCardErrorMessage = 'This phone number or access card # does not exist.';
            }
            $.caAlertCallback(
                '<div class="ca-access-card-error-text">'+accessCardErrorMessage+'<div>',
                "Warning!",
                function () {
                    this.element.focus();
                },
                {
                    className: "ca-access-card-error",
                    fade: true
                }
            );
        }
    });
})(jQuery);
